import { PurchaseDto } from 'services/Order/orderService.dto';

export const calculateServiceFee = ({ amountTotal, basePrice, shipmentPrice }: PurchaseDto): number => {
  return Math.round((amountTotal - basePrice - shipmentPrice) * 100) / 100;
};
